import React from 'react';
import { EngagementProvider } from './engagement-context';
import { KeywordsScreen } from './keywords';

const EngagementScreen = () => {
  return (
    <EngagementProvider>
      <KeywordsScreen />
    </EngagementProvider>
  );
};

export { EngagementScreen };
